/**
 * Список отзывов
 *
 * @param {Object} [options]
 * @param {String} options.feedbackListSelector
 * @param {Object} params
 * @param {String} params.urlApi - url обращения к api citySelect
 * @param {String} params.urlApiSpecialization - url обращения к api специализаций врачей
 * @param {String} params.feedbackList - список отзывов
 * @param {String} params.choiceClinic - выбор клиники
 * @param {String} params.specializationsList - список специализаций
 * @param {String} params.specializationTitle - название специализации
 * @param {String} params.searchSpecialization - блок поиска специализации
 * @param {String} params.selectSpecialization - селект выбора специализации
 * @param {String} params.specializationField - поле поиска специализации
 * @param {String} params.specializationClear - кнопка очистки названия специализации
 * @param {String} params.fioField - поле ФИО
 * @param {String} params.fioClear - кнопка очистки ФИО
 */
$.fn.feedbackList = function (options) {
    const defaults = {
        feedbackListSelector: '#feedback-list'
    };

    const settings = $.extend({}, defaults, options);
    const $self = $(this);
    const $feedbackListFilter = $self.find('.js-feedback-list-filter');
    const $feedbackList = $self.find(settings.feedbackListSelector);

    const $specializationField = $feedbackListFilter.find('.js-specialization-field');
    const $specializationList = $feedbackListFilter.find('.js-specialization-list');
    const $nameField = $feedbackListFilter.find('.js-name-field');
    const $clinicSelect = $feedbackListFilter.find('.js-clinic-select');

    const feedbackApiUrl = $feedbackList.data('feedback-url-api');
    const specializationApiUrl = $feedbackList.data('specializations-url-api');

    let inputTimer;

    /**
     * Рендер списка специализаций
     */
    const updateSpecList = function () {
        $.ajax({
            method: 'GET',
            url: specializationApiUrl,
            data: {
                specialization: $specializationField.val().trim(),
                clinic_id: $clinicSelect.val(),
            }
        }).done(function (data) {
            $specializationList.html(data);
            $specializationList
                .closest('.js-search-filter-wrapper')
                .toggleClass('suggest-available', !!data); // если пришёл не пустой ответ - показываем список
        }).fail(function (error) {
            console.error(error);
        });
    };

    /**
     * Рендер списка докторов
     */
    const updateFeedbackList = function () {
        $.ajax({
            method: 'GET',
            url: feedbackApiUrl,
            data: {
                fio: $nameField.val().trim(),
                specialization: $specializationField.val().trim(),
                clinic_id: $clinicSelect.val(),
            }
        }).done(function (res) {
            $feedbackList.html(res);
            updateUrl();
        }).fail(function (error) {
            console.error(error);
        });
    };

    /**
     * Получение значения GET-параметра
     *
     * @param {string} paramName
     *
     * @returns {string}
     */
    const getParamFromUrl = function (paramName) {
        let urlParamsArray = window.location.search.substring(1).split('&');
        let urlParamsObj = {};

        urlParamsArray.forEach(function (el) {
            let [name, value] = el.split('=');
            urlParamsObj[name] = decodeURIComponent(value);
        });

        if (urlParamsObj.hasOwnProperty(paramName)) {
            return urlParamsObj[paramName];
        }

        return '';
    };

    /**
     * Обновление урла при изменении фильтров
     */
    const updateUrl = function () {
        const DEFAULT_PAGE = '1';

        const clinicId = $clinicSelect.val();
        const fio = $nameField.val().trim();
        const specialization = $specializationField.val().trim();
        let newUrl = new URL(window.location.protocol + "//" + window.location.host + window.location.pathname);

        if (fio) {
            newUrl.searchParams.set('fio', fio);
        }

        if (clinicId) {
            newUrl.searchParams.set('clinic_id', clinicId);
        }

        if (specialization) {
            newUrl.searchParams.set('specialization', specialization);
        }

        newUrl.searchParams.set('page', DEFAULT_PAGE);

        if (getParamFromUrl('page') && getParamFromUrl('page') !== DEFAULT_PAGE) {
            window.location.search = newUrl.search
        } else {
            window.history.pushState({path:newUrl.href},'', newUrl.href);
        }
    };

    /**
     * Инициализация
     */
    const init = function () {
        $nameField.data('current-value', $nameField.val().trim());

        if (getParamFromUrl('specialization')) {
            $specializationField.val(getParamFromUrl('specialization')).trigger('change');
        }

        $specializationField.on('focus input', function () {
            updateSpecList();
        });

        $specializationField.on('blur', function () {
            clearInterval(inputTimer);
            inputTimer = setTimeout(function () {
                $specializationList.empty();
                $specializationList
                    .closest('.js-search-filter-wrapper')
                    .removeClass('suggest-available');
            }, 200);
        });

        $specializationField.on('change', function () {
            updateFeedbackList();
            $specializationList.empty();
            $specializationList
                .closest('.js-search-filter-wrapper')
                .removeClass('suggest-available');
        });

        $specializationField.on('keyup', function (e) {
            switch (e.key) {
                case 'ArrowDown':
                    $(this).blur();
                    $specializationList
                        .find('.js-suggest-item a')
                        .first()
                        .focus();
                    break;

                case 'Enter':
                    $(this)
                        .blur()
                        .closest('.js-search-filter-wrapper')
                        .removeClass('suggest-available');
                    break;
            }
        });

        $specializationList.on('click', '.js-suggest-item', function () {
            let $t = $(this);
            $specializationField
                .val($t.text().trim())
                .trigger('change');
        });

        $specializationList.on('keydown', '.js-suggest-item a', function (e) {

            let $items = $specializationList.find('.js-suggest-item');
            let $currentItem = $(this).closest('.js-suggest-item');

            switch (e.key) {
                case 'ArrowDown':
                    $items
                        .eq(($currentItem.index() + 1) % $items.length)
                        .find('a')
                        .focus();
                    break;

                case 'ArrowUp':
                    $items
                        .eq(($currentItem.index() + $items.length - 1) % $items.length)
                        .find('a')
                        .focus();
                    break;
            }

            return false;
        });

        $nameField.on('focus input', function () {
            let $t = $(this);
            clearInterval(inputTimer);
            inputTimer = setTimeout(function () {
                if ($t.data('current-value') !== $t.val().trim()) {
                    $t.data('current-value', $t.val().trim());
                    updateFeedbackList();
                }
            }, 200);
        });

        $clinicSelect.on('change', function () {
            updateFeedbackList();
        });


        //инициализация кастомного скроллбара на списке специализаций
        $specializationList.on('transitionend', function () {
            tools.initCustomScroll($specializationList);
            if ($specializationList.outerHeight() < parseFloat($specializationList.css('max-height'))) {
                tools.destroyCustomScroll($specializationList);
            } else {
                tools.updateCustomScroll($specializationList);
            }
        });
    };

    init();

    return this;
};

// инициализация
$('#feedback-list-module').each(function () {
    $(this).feedbackList();
});

window.addEventListener('mouseover',(e) => {
    if (typeof e.target === 'object' && 'getAttribute' in e.target) {
        let x = e.target.getAttribute('data-specialization-title');

        if (x === null) {
            return;
        }

        document.querySelector('.js-specialization-field').value = x;
    }
});
